import utils from 'helpers/utils';
import constants from 'helpers/constants';

function processedMessage (type, conversation) {
  if (constants.assistant.types.search === type) {
    return utils.toArray(conversation).findLast((c) => {
      return c.role === constants.assistant.conversation.roles.user &&
        utils.isDefined(c.results?.entities) && utils.isDefined(c.progress?.page) &&
        (c.progress?.total ?? 0) > 0;
    });
  }
}

function processedCount (type, conversation) {
  if (utils.isDefined(processedMessage(type, conversation))) {
    return 1;
  } else {
    return 0;
  }
}

function questionOptionIndex (conversation, tilt, questionIndex = 0) {
  const questionTypes = [constants.assistant.adviceActionTypes.askQuestion, constants.assistant.adviceActionTypes.needMoreInfo];
  const options = utils.toArray(conversation).findLast((c) => {
    return c.role === constants.assistant.conversation.roles.user;
  })?.results?.actions?.find((action) => {
    return questionTypes.includes(action.id);
  })?.details?.[questionIndex]?.options;
  const index = utils.toArray(options).findIndex((opt) => {
    return opt?.tilt === tilt;
  });

  return index >= 0 ? index : null;
}

function lastProfile (conversation) {
  return utils.toArray(conversation).findLast((c) => {
    return c.role === constants.assistant.conversation.roles.user && utils.isDefined(c.results?.profile);
  })?.results?.profile ?? null;
}

const assistant = {
  processedMessage,
  processedCount,
  questionOptionIndex,
  lastProfile
};

export default assistant;
